import React from 'react';
import { async } from 'components/helpers/routerUtils';
import AppHomeRoute from 'routes/AppHomeRoute';
import { Route, IndexRedirect } from 'react-router';

const Register = async(() => import('components/pages/Register/Register'));
const RegisterStep1 = async(() => import('components/pages/Register/Step1'));
const RegisterStep2 = async(() => import('components/pages/Register/Step2'));
const RegisterStep3 = async(() => import('components/pages/Register/Step3'));

const RegisterRoutes = (
  <Route path="register" getComponent={Register} queries={AppHomeRoute.queries}>
    <IndexRedirect to="step1" />
    <Route path="step1" getComponent={RegisterStep1} />
    <Route path="step2" getComponent={RegisterStep2} />
    <Route path="step3" getComponent={RegisterStep3} />
  </Route>
);

export default RegisterRoutes;



// WEBPACK FOOTER //
// ./js/RegisterRoutes.js